import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { MessageBox, MessageBoxVariant } from "../../../../components/MessageBox/MessageBox";
import { useTranslations } from "../../../../providers/useTranslations";
import { useStoreLocatorContext } from "../../hooks";
import { useDisplayType } from "../../hooks/useDisplayType";
import { StoreLocatorCardList } from "../StoreLocatorCardList";
import { StoreLocatorMap } from "../StoreLocatorMap";
import { StoreLocatorMobileInfoContainer } from "../StoreLocatorMobileInfoContainer";
import { StoreLocatorSearchBar } from "../StoreLocatorSearchBar";
import styles from "./StoreLocatorV1.module.scss";
export const StoreLocatorV1 = () => {
    const { __ } = useTranslations();
    const { change, isMap } = useDisplayType("map");
    const onChangeResultType = (type) => {
        change(flotiqStores.length > 0 ? type : "map");
    };
    const { flotiqStores, isNoMatchingFlotiqStores } = useStoreLocatorContext();
    return (_jsxs("div", { className: styles.mainContainer, children: [_jsx(StoreLocatorSearchBar, {}), _jsx(StoreLocatorMobileInfoContainer, { onChangeResultType: onChangeResultType }), isNoMatchingFlotiqStores && (_jsx(MessageBox, { className: styles.warningMessage, variant: MessageBoxVariant.warning, isVisible: true, children: __("cart.checkout.delivery.in_store.attributes_filtering.no_matches_found") })), _jsxs("div", { className: styles.resultsContainer, children: [_jsx(StoreLocatorCardList, { isMapView: isMap }), _jsx("div", { className: classNames(styles.mapContainer, {
                            [styles.mapContainerHidden]: !isMap,
                        }), children: _jsx(StoreLocatorMap, { className: styles.mapWrapper, mapClassName: styles.map }) })] })] }));
};
//# sourceMappingURL=StoreLocatorV1.js.map